import { EntityCreateResponse } from '@faro/http-clients';
import {
    CommandResponse,
    Endpoint,
    RevisionedCommandResponse,
    ScheduleOfActivities,
    toEndpoint,
} from '@faro/study-designer-model';
import axios from 'axios';
import { Identifiable } from 'faro-common-model';
import { RevisionQueryParameter, StudyPathParameter } from '../parameter';
import { ScheduleOfActivitiesPathParameters } from '../ScheduleOfActivities/ScheduleOfActivitiesClient';

export type EndpointPathParameters = StudyPathParameter;
export type EndpointQueryParameters = RevisionQueryParameter;

export const endpointClient = {
    list: async (
        query: EndpointPathParameters & EndpointQueryParameters,
        signal?: AbortSignal
    ): Promise<Endpoint[]> => {
        const { studyId, ...params } = query;
        const response = await axios.get(`/api/study-designer/studies/${studyId}/endpoints`, {
            params,
            signal,
        });
        return response.data.map(toEndpoint);
    },
    get: async (query: EndpointPathParameters & { id: string }, signal?: AbortSignal): Promise<Endpoint> => {
        const { studyId, id } = query;
        const response = await axios.get(`/api/study-designer/studies/${studyId}/endpoints/${id}`, {
            signal,
        });
        return toEndpoint(response.data);
    },
    create: async (data: Partial<Omit<Endpoint, 'id'>>, signal?: AbortSignal): Promise<CommandResponse> => {
        const { studyId, ...body } = data;
        const response = await axios.post(`/api/study-designer/studies/${studyId}/endpoints`, body, {
            signal,
        });
        return response.data;
    },
    delete: async (
        data: EndpointPathParameters & { id: string },
        signal?: AbortSignal
    ): Promise<RevisionedCommandResponse<any>> => {
        const { studyId, id } = data;
        const response = await axios.delete(`/api/study-designer/studies/${studyId}/endpoints/${id}`, {
            signal,
        });
        return response.data;
    },
    clone: async (entity: Partial<ScheduleOfActivities>, signal?: AbortSignal): Promise<EntityCreateResponse> => {
        const { studyId, id } = entity;
        const response = await axios.post(
            `/api/study-designer/studies/${studyId}/endpoints/${id}/actions/clone`,
            entity,
            {
                signal,
            }
        );
        return {
            id: response.data.entityId,
            revision: response.data.revision,
        };
    },
    move: async (
        request: ScheduleOfActivitiesPathParameters &
            Identifiable & { sequenceNumber: number } & { from: number; to: number },
        signal?: AbortSignal
    ): Promise<RevisionedCommandResponse<CommandResponse>> => {
        const { studyId, id, sequenceNumber } = request;
        const response = await axios.post(
            `/api/study-designer/studies/${studyId}/endpoints/${id}/actions/move`,
            { sequenceNumber },
            { signal }
        );
        return response.data;
    },
};
